import { Navigate, Outlet } from 'react-router-dom'
import AppLayout from './AppLayout';
const DonorRoutes = () => {
    const token = window.localStorage.getItem('token');
    const donor = window.localStorage.getItem('donor')?.toString();
    return (
        token && donor == "true" ? <AppLayout><Outlet /></AppLayout> : <Navigate to='/login' />
    )
}
export default DonorRoutes;